import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '../../../../../../../global.service';
@Component({
  selector: 'app-carousel-of-items',
  templateUrl: './carousel-of-items.component.html',
  styleUrls: ['./carousel-of-items.component.sass']
})
export class CarouselOfItemsComponent implements OnInit {
  @Input() premiumChannels: any;
  @Output() update = new EventEmitter<any>();
  public idSelectedChannels: string[] = [];
  constructor(public global: GlobalService) { }
  ngOnInit(): void {}
  addItem(idChannel: string, check: boolean) {
    if (check==true) {
      this.idSelectedChannels.push(idChannel);
      this.update.emit(this.idSelectedChannels);
    }
    else {
      this.global.notif("Por favor acepte los términos y condiciones.");
    }
  }
  isSelected(idChannel: string) {
    let is: boolean = false;
    for (let i = 0; i < this.idSelectedChannels.length; i++) {
      if (this.idSelectedChannels[i] == idChannel) {
        is = true;
      }
    }
    return is;
  }
  removeItem(idChannel:string,i:number,j:number) {
    this.premiumChannels[i][j].check=false;
    const index = this.idSelectedChannels.indexOf(idChannel);
    if (index > -1) {
      this.idSelectedChannels.splice(index, 1);
    }
    this.update.emit(this.idSelectedChannels);
  }
}